export interface IGetAppearAnimationParams {
    baseDelay?: number
    initialOpacity?: number
    duration?: number
    indexDelay?: number
    indexDelayRateChange?: number
    ease?: 'linear' | 'easeIn' | 'easeOut' | 'easeInOut'
    y?: number | boolean
    yStiffness?: number
}

export const getAppearAnimation = (
    index: number,
    {
        initialOpacity = 0,
        baseDelay = 0,
        duration,
        indexDelay = 0.05,
        indexDelayRateChange = 0,
        ease = 'easeIn',
        y = 0,
        yStiffness = 220,
    }: IGetAppearAnimationParams = {}
) => {
    const yValue = typeof y === 'number' ? y : y === true ? 20 : undefined

    const durationValue =
        typeof duration === 'number' ? duration : typeof yValue === 'number' ? 0.5 : 0.35

    const delayValue = baseDelay + index * indexDelay + indexDelayRateChange * index * index

    return {
        initial: { opacity: initialOpacity, y: yValue },
        animate: { opacity: 1, y: typeof yValue === 'number' ? 0 : undefined },
        transition: {
            opacity: {
                duration: durationValue,
                ease,
                delay: delayValue,
            },
            y: {
                type: 'spring' as const,
                delay: delayValue,
                stiffness: yStiffness,
                damping: 35,
            },
        },
    }
}
